<template>
  <v-dialog v-model="dialog" scrollable width="1000">
    <template v-slot:activator="{ on }">
      <v-btn class="mr-5" v-on="on" color="primary">{{$t('DataHome.filter')}}</v-btn>
    </template>

    <v-card id="card" :height="cardSize" min-height="500px">
      <v-card-title class="title grey lighten-2" primary-title>{{$t('DataHome.filter-title')}}</v-card-title>
      <v-card-text class="mt-5">
        <v-row align="center" justify="space-between">
          <v-col cols="12">
            <div class="v-label" v-text="$t('DataHome.quantity')"></div>
          </v-col>
          <v-col cols="12">
            <number-input
              v-model="newQuantity"
              :min="1"
              :max="50"
              size="small"
              inline
              center
              controls
            ></number-input>
          </v-col>
        </v-row>

        <v-checkbox v-model="newCheckbox" :label="checkboxMsg"></v-checkbox>

        <v-checkbox v-model="newFilterDate" :label="$t('DataHome.filterDate')"></v-checkbox>
        <template v-if="newFilterDate">
          <v-text-field label="From" v-model="minTotalDate" readonly solo>
            <v-btn slot="append" color="primary" @click="resetMinDate">{{$t('DataHome.reset')}}</v-btn>
          </v-text-field>

          <v-row>
            <v-col class="text-center" cols="12" sm="6">
              <v-date-picker
                :show-current="true"
                :locale="$t('DataHome.dateformat')"
                v-model="minDay"
              ></v-date-picker>
            </v-col>
            <v-col class="text-center" cols="12" sm="6">
              <v-time-picker use-seconds :show-current="true" format="24hr" v-model="minTime"></v-time-picker>
            </v-col>
          </v-row>

          <v-text-field label="To" v-model="maxTotalDate" readonly solo>
            <v-btn slot="append" color="primary" @click="resetMaxDate">{{$t('DataHome.reset')}}</v-btn>
          </v-text-field>
          <v-row>
            <v-col class="text-center" cols="12" sm="6">
              <v-date-picker
                :show-current="true"
                :locale="$t('DataHome.dateformat')"
                v-model="maxDay"
              ></v-date-picker>
            </v-col>
            <v-col class="text-center" cols="12" sm="6">
              <v-time-picker use-seconds :show-current="true" format="24hr" v-model="maxTime"></v-time-picker>
            </v-col>
          </v-row>
        </template>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions fixed>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('DataHome.back')}}</v-btn>
        <v-btn color="primary" text @click="sendFilterParams">{{$t('DataHome.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    quantity: Number,
    checkbox: Boolean,
    filterDate: Boolean,
    minDate: Number,
    maxDate: Number,
  },
  data() {
    return {
      dialog: false,
      newQuantity: null,
      newCheckbox: null,
      newFilterDate: null,
      newMinDate: null,
      newMaxDate: null,
      windowHeight: 0,
      minTime: null,
      maxTime: null,
      minDay: null,
      maxDay: null
    };
  },
  watch: {
    newFilterDate: function() {
      let minDate = new Date(this.newMinDate);
      let maxDate = new Date(this.newMaxDate);
      this.minDay = minDate.toISOString().substring(0, 10);
      this.maxDay = maxDate.toISOString().substring(0, 10);
      this.minTime = minDate.toTimeString().substring(0,8);
      this.maxTime = maxDate.toTimeString().substring(0,8);

    },
    dialog: function() {
      this.newQuantity = this.quantity;
      this.newCheckbox = this.checkbox;
      this.newFilterDate = this.filterDate;
      this.newMinDate = this.minDate;
      this.newMaxDate = this.maxDate;
    }
  },
  computed: {
    checkboxMsg: function() {
      if (!this.newCheckbox) {
        return this.$t("DataHome.dialogCheckTrue");
      } else {
        return this.$t("DataHome.dialogCheckFalse");
      }
    },
    minTotalDate: function() {
      return (
        this.$t("DataHome.from") +
        " " +
        this.minDay +
        " " +
        this.$t("DataHome.at") +
        " " +
        this.minTime
      );
    },
    maxTotalDate: function() {
      return (
        this.$t("DataHome.to") +
        " " +
        this.maxDay +
        " " +
        this.$t("DataHome.at") +
        " " +
        this.maxTime
      );
    },
    cardSize: function() {
      if (this.filterDate) {
        return this.windowHeight * 0.8 + "px";
      } else {
        return "";
      }
    }
  },
  methods: {
    sendFilterParams: function() {
      this.dialog = false;
      this.$emit("filter", {
        quantity: this.newQuantity,
        checkbox: this.newCheckbox,
        filterDate: this.newFilterDate,
        minDate: new Date(this.minDay + " " + this.minTime).getTime()-999,
        maxDate: new Date(this.maxDay + " " + this.maxTime).getTime()+999
        
      });
      console.log(new Date(this.minDay + " " + this.minTime).getTime())
    },
    resetMinDate() {
      let minDate = new Date(this.newMinDate);
      this.minDay = minDate.toISOString().substring(0, 10);
      this.minTime = minDate.toTimeString().substring(0,8);
    },
    resetMaxDate() {
      let maxDate = new Date(this.newMaxDate);
      this.maxDay = maxDate.toISOString().substring(0, 10);
      this.maxTime = maxDate.toTimeString().substring(0,8);
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    }
  },
  beforeMount: function() {
    this.newQuantity = this.quantity;
    this.newCheckbox = this.checkbox;
    this.newFilterDate = this.filterDate;
    this.newMinDate = this.minDate;
    this.newMaxDate = this.maxDate;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>


